export default {"src":"/_next/static/media/block-factory.5d8d30dc.svg","height":396,"width":387};